/**
 * «N фраз ждут повторения» — повод вернуться сегодня, в приложении.
 *
 * Число — из умного повторения (FSRS): фразы, которые ученик вот-вот
 * забудет. Нечего повторять или нет сети — карточки нет.
 */

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { fetchSmartReview } from '../../api/vocabulary';
import { useUserStore } from '../../store/userStore';
import { Button } from '../Button';
import { IconCards } from '../icons';

export function ReviewDueCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userId = useUserStore((state) => state.userId);
  const [due, setDue] = useState(0);

  useEffect(() => {
    if (userId.length === 0) return undefined;
    let cancelled = false;
    fetchSmartReview(userId, 1)
      .then((deck) => !cancelled && setDue(deck.weakCount))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [userId]);

  if (due === 0) return null;
  return (
    <motion.section
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      aria-label={t('reviewDue.title', { count: due })}
      className="glass flex flex-col gap-4 rounded-card border border-line p-5 shadow-card sm:flex-row sm:items-center sm:p-6"
    >
      <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-accent/20 text-accent-dark">
        <IconCards size={28} stroke={1.8} aria-hidden="true" />
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h2 className="t-h2">{t('reviewDue.title', { count: due })}</h2>
        <p className="text-muted">{t('reviewDue.text')}</p>
      </div>
      <Button onClick={() => navigate('/pocket', { state: { mode: 'smart' } })}>{t('reviewDue.go')}</Button>
    </motion.section>
  );
}
